export default __webpack_public_path__ + "static/media/airplane.643b4d3e.svg";